import React, { useState } from "react"
import { useEffect } from "react"
import { createPortal } from "react-dom"
import { Navigate, useSearchParams } from "react-router-dom"

import { USER_ROUTES } from "@constants"
import { userData } from "@signals"
import { isIrisUser } from "Layout/PmsAgentWidget"
import PageWrapper from "../../@PageWrapper"
import { clearUserSettingsSignals } from "./@signals"
import { USER_SETTINGS_TABS_ID } from "./@constants"
import { useUserSettingsTabs } from "./@hooks"
import UserSettingContent from "./Content"
import { irisRedirect } from "./@services/tabs"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from './VirtualTour'
import SettingsDemoData from './VirtualTour/DemoData'
import { isTourDemoActive } from '@signals/app'


export default function UserSettingPage() {
    const [tourActive, setTourActive] = useState(false)
    const { requestTab } = useUserSettingsTabs()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        return clearUserSettingsSignals
    }, [])

    // The tour always runs on Tiers: its steps point at the open tab's "Define…" button and table and its
    // demo rows are Tiers' (`VirtualTour/steps.js`, `DemoData.jsx`). Account opens by default and has
    // neither, so the tour moves there first — asking if Account has unsaved changes.
    const startTour = () => requestTab(USER_SETTINGS_TABS_ID.TIER, {
        then: () => { setTourActive(true); isTourDemoActive.value = true },
    })

    // `?tab=iris` is the Iris page now (CU-869fmherf D4): pasted, or arriving with Settings open (a saved
    // chat link). Read on every render, so it redirects in both cases; unsaved Account edits are not asked
    // about (accepted, as leaving by the side menu)
    const irisTo = irisRedirect({ param: searchParams.get('tab'), isIris: isIrisUser(userData.value?.username) })
    if (irisTo) return <Navigate to={irisTo} replace/>

    return <PageWrapper
        head={`DS Rentacar | ${USER_ROUTES.TITLE}`}
        title={USER_ROUTES.TITLE}
        subtitle={USER_ROUTES.SETTINGS_SUBTITLE}
        actions={<VirtualTourButton onClick={startTour} />}
    >
        <UserSettingContent />
        {tourActive && <SettingsDemoData />}
        {tourActive && createPortal(
            <TourOverlay steps={TOUR_STEPS} onClose={() => { setTourActive(false); isTourDemoActive.value = false }} />,
            document.body
        )}
    </PageWrapper>
}